//-- copyright
// OpenProject is an open source project management software.
// Copyright (C) the OpenProject GmbH
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
//
// See COPYRIGHT and LICENSE files for more details.
//++

import { ChangeDetectionStrategy, Component, Injector, OnInit, inject } from '@angular/core';
import { I18nService } from 'core-app/core/i18n/i18n.service';
import { TabComponent } from 'core-app/features/work-packages/components/wp-table/configuration-modal/tab-portal-outlet';
import { OpModalLocalsMap } from 'core-app/shared/components/modal/modal.types';
import { OpModalLocalsToken } from 'core-app/shared/components/modal/modal.service';
import { Board } from 'core-app/features/boards/board/board';
import { CardHighlightingMode } from 'core-app/features/work-packages/components/wp-fast-table/builders/highlighting/highlighting-mode.const';

@Component({
  templateUrl: './highlighting-tab.component.html',
  standalone: false,
  // TODO: This component has been partially migrated to be zoneless-compatible.
  // After testing, this should be updated to ChangeDetectionStrategy.OnPush.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BoardHighlightingTabComponent implements TabComponent, OnInit {
  readonly injector = inject(Injector);
  locals = inject<OpModalLocalsMap>(OpModalLocalsToken);
  readonly I18n = inject(I18nService);

  // Highlighting mode
  public highlightingMode:CardHighlightingMode = 'none';

  public entireCardMode = false;

  public lastEntireCardAttribute:CardHighlightingMode = 'type';

  // Current board resource
  public board:Board;

  public text = {
    highlighting_mode: {
      description: this.I18n.t('js.work_packages.table_configuration.highlighting_mode.description'),
      none: this.I18n.t('js.work_packages.table_configuration.highlighting_mode.none'),
      type: this.I18n.t('js.work_packages.properties.type'),
      priority: this.I18n.t('js.work_packages.table_configuration.highlighting_mode.priority'),
      entire_card_by: this.I18n.t('js.card.highlighting.entire_card_by'),
    },
  };

  public onSave() {
    this.updateMode(this.highlightingMode);
    this.board.highlightingMode = this.highlightingMode;
  }

  ngOnInit() {
    this.board = this.locals.board;
    this.highlightingMode = this.board.highlightingMode;
    this.updateMode(this.highlightingMode);
  }

  public updateMode(mode:CardHighlightingMode) {
    if (mode === 'inline') {
      this.highlightingMode = this.lastEntireCardAttribute;
    } else {
      this.highlightingMode = mode;
    }

    if (['priority', 'type'].includes(this.highlightingMode)) {
      this.lastEntireCardAttribute = this.highlightingMode;
      this.entireCardMode = true;
    } else {
      this.entireCardMode = false;
    }
  }
}
